import {Injectable} from '@angular/core';
import { ProgressService } from './progress.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UnsavedChangesDialog } from '../components/dialogs/unsaved-changes-dialog/unsaved-changes-dialog';

@Injectable()
export class UnsavedChangesService {
    constructor(
        private progressService: ProgressService,
        private modalService: NgbModal
    ) {}

    openDialog(isRouting = false): Promise<any> {
        this.progressService.stopProgress(isRouting);
        let p = new Promise<boolean>((resolve, reject) => {
            this.modalService.open(UnsavedChangesDialog).result
                .then(() => {
                    this.progressService.startProgress(isRouting);
                    resolve(true);
                }, () => {
                    resolve(false);
                });
        });
        return p;
    }
}
